import { AnimatePresence, motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';

interface PapErrorsProps {
  errors?: string[];
}

const PapErrors: React.FC<PapErrorsProps> = ({ errors = [] }) => {
  return (
    <AnimatePresence>
      {errors.length > 0 && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.2 }}
          className="mb-5"
        >
          <div className="p-4 bg-destructive/10 dark:bg-destructive/15 border border-destructive/20 rounded-xl">
            {errors.map((error) => (
              <p key={error} className="text-sm text-destructive font-medium flex items-center gap-2">
                <AlertCircle className="w-4 h-4 shrink-0" />
                {error}
              </p>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PapErrors;
